export const _LOAD_MODEL_ = 'Load:RepresentativeModel';
export const _DELETE_REPRESENTATIVE_ = 'Delete:Representative';
export const _EDIT_REPRESENTATIVE_ = 'Save:RepresentativeSuccess';
export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';
export const _SAVE_RESELLER_SUCCESS_ = 'Save:RepresentativeSuccess';

export const ATTACHED = 'attached';
export const DETACHED = 'detached';

export const MODEL = {
  id: null,
  name: null,
  email: null,
  phone: null,
};
